import { styled } from '@mui/material/styles';
import { Grid2 } from '@aibees/shared/components';

export const Wrapper = styled(Grid2)``;
